import { IState } from 'shared/store';

export const selectChatRequestStatus = (state: IState) => {
  return state.offerChat.requestStatus;
};
